import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import withTranslation from '@helpers/i18n'
import BooleanSwitch from 'react/components/forms/boolean_switch'
import styled from 'styled-components'
import snakeCase from 'lodash/snakeCase'

const LOCALSTORAGE_COOKIES_KEY = 'Dokeos::CookiesState'

const CookieDesc = styled.p`
  padding: 0;
  margin: 0;
  font-size: 12px;
  color: #a1a1a1;
`

class Cookies extends React.Component {
  constructor(props) {
    super(props)

    this.onCookieStateChange = this.onCookieStateChange.bind(this)
    this._getCookiesState = this._getCookiesState.bind(this)
    this._fetchCookiesState = this._fetchCookiesState.bind(this)
    this._setCookiesStateLocalStorage = this._setCookiesStateLocalStorage.bind(this)
    this._removeCookie = this._removeCookie.bind(this)
  }

  onCookieStateChange(cookie, state) {
    let cookiesState = this._getCookiesState()
    cookiesState[cookie] = state
    this._setCookiesStateLocalStorage(cookiesState)
    if (!state) {
      this._removeCookie(cookie)
    }
  }

  render() {
    const { t, cookies_type } = this.props
    const cookiesState = this._getCookiesState()
    return (
      <Fragment>
        {cookies_type.map((type) => (
          <div className="margin-bottom-20">
            <table className="table">
              <thead>
                <tr>
                  <th>{t(`.${type.type}`)}</th>
                </tr>
              </thead>
              <tbody>
                {type.cookies.map((cookie) => (
                  <tr className="card card-boolean mt-20" data-purpose="cookie">
                    <td>
                      <span data-purpose="name">{t(`.${snakeCase(cookie.name)}`)}</span>
                      <br />
                      <CookieDesc>{t(`.${snakeCase(cookie.name)}_desc`)}</CookieDesc>
                    </td>
                    <td>
                      <div>
                        <BooleanSwitch
                          id={cookie.name}
                          name={cookie.name}
                          value={cookiesState[cookie.name]}
                          disabled={!cookie.optional}
                          onChange={(target) => {
                            this.onCookieStateChange(cookie.name, target.checked)
                          }}
                          attributes={{ 'data-purpose': 'cookie_state_switch' }}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </Fragment>
    )
  }

  _getCookiesState() {
    return JSON.parse(this._fetchCookiesState()) || {}
  }

  _fetchCookiesState() {
    return localStorage.getItem(LOCALSTORAGE_COOKIES_KEY)
  }

  _setCookiesStateLocalStorage(states) {
    localStorage.setItem(LOCALSTORAGE_COOKIES_KEY, JSON.stringify(states))
  }

  _removeCookie(cookie) {
    localStorage.removeItem(cookie)
  }
}

Cookies.propTypes = {
  t: PropTypes.func.isRequired,
  cookies: PropTypes.array.isRequired,
}

Cookies.defaultProps = {
  cookies: [],
}
export default withTranslation('js.components.cookies')(Cookies)
